import React from 'react';
import { EmbedParamsModel, embedParamsModelInitial } from '../../Models/EmbedParamsModel';

import { DashboardStatus } from './enums/DashboardStatus';

export interface IDashboardContext {
    dashboardStatus: DashboardStatus,
    setDashboardStatus: (status: DashboardStatus) => void,
    embedParams: EmbedParamsModel,
    setEmbedParamas: (embedParams: EmbedParamsModel) => void,
    errorMessage: string,
    setErrorMessage (value: string): void,
}

export const dashboardContextInitial: IDashboardContext = {
    dashboardStatus: DashboardStatus.DEFAULT,
    setDashboardStatus: () => { ''; },
    embedParams: embedParamsModelInitial,
    setEmbedParamas: () => { ''; },
    errorMessage: '',
    setErrorMessage: () => { ''; },
};

export const DashboardContext = React.createContext(dashboardContextInitial);
